import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { BoxImage } from './BoxImage';
const modules = [{
  title: 'ELITE RUNNING PROGRAM LIBRARY™',
  description: 'Una libreria completa di programmi professionali per 5K, 10K, Mezza Maratona, Maratona e Trail Running, con pianificazioni già sviluppate per differenti livelli, obiettivi e durate. Include calendari, progressioni e versioni modificabili pronte da utilizzare.'
}, {
  title: 'PROFESSIONAL RUNNING SESSION BUILDER™',
  description: 'Una vasta raccolta di allenamenti organizzati per velocità, soglia, VO₂max, resistenza, fartlek, lavori in salita, recupero e tecnica di corsa. Ogni sessione è già strutturata con volumi, recuperi, progressioni e varianti per diversi livelli di preparazione.'
}, {
  title: 'STRENGTH & PERFORMANCE SYSTEMS™',
  description: 'Programmi completi di forza, mobilità, stabilità e prevenzione degli infortuni specifici per runner. Include routine per palestra, corpo libero ed elastici, con schede professionali immediatamente integrabili in qualsiasi pianificazione.'
}, {
  title: 'ATHLETE ASSESSMENT & PROGRESS TOOLKIT™',
  description: 'Un sistema professionale dedicato alla valutazione e al monitoraggio degli atleti durante tutta la stagione. Include test per velocità, resistenza, soglia, capacità aerobica, forza e mobilità, oltre a schede di valutazione iniziale, registri dei carichi di lavoro, report sui progressi e strumenti pratici per analizzare l\'evoluzione delle prestazioni e prendere decisioni basate sui dati.'
}, {
  title: 'RUNNING COACHING RESOURCES VAULT™',
  description: 'Una raccolta completa di risorse professionali già pronte da consegnare agli atleti. Include guide pre-gara, protocolli di riscaldamento, strategie di recupero, indicazioni su alimentazione e idratazione, checklist operative, schede educative e materiali pratici che aumentano il valore del servizio offerto dal coach.'
}, {
  title: 'COMPLETE COACHING PLANNING SYSTEM™',
  description: 'Il sistema definitivo per organizzare l\'intera stagione sportiva. Comprende macrocicli, mesocicli, microcicli, calendari annuali, pianificazione delle competizioni, gestione dei gruppi, organizzazione degli obiettivi e modelli professionali pronti all\'uso per semplificare ogni fase del lavoro del running coach.'
}];
export function ModulesSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-85" data-mp="36shpg7923z20">
      <div className="text-center mb-4" data-id="element-86" data-mp="31teu5eivp778">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-gold-dark uppercase tracking-widest mb-1" data-id="element-87" data-mp="31ug41fo5rnnd">
          La Soluzione che Stavi Cercando
        </p>
        <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-navy leading-tight uppercase mb-2" data-id="element-88" data-mp="2su06emu3jaqf">
          Un Sistema Completo 6-in-1 per Running Coach
        </h2>
        <div className="inline-block bg-navy text-white px-4 py-1.5 rounded mb-2.5" data-id="element-89" data-mp="1hebint90q7ok">
          <p className="font-heading font-bold text-xs sm:text-sm tracking-widest uppercase" data-id="element-90" data-mp="3t1f0x3xkj0fu">
            🏃 RUNNING COACH PRO™
          </p>
        </div>

        <BoxImage wrapperClassName="mb-2.5" className="max-w-[220px] sm:max-w-xs drop-shadow-lg" data-id="element-91" data-mp="y5nojv7cm24" />

        <p className="max-w-2xl mx-auto text-anthracite text-[12.5px] sm:text-base leading-relaxed" data-id="element-92" data-mp="5uw4j9etzlol">
          Più di una raccolta di allenamenti. Più di una semplice libreria di
          esercizi.{' '}
          <span className="font-semibold text-navy" data-id="element-93" data-mp="fov5w672z1fh">
            RUNNING COACH PRO™ è un sistema professionale progettato per
            permetterti di preparare programmi completi in pochi minuti,
            organizzare l'intera stagione dei tuoi atleti e lavorare ogni giorno
            con materiale professionale già pronto.
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-2 max-w-3xl mx-auto" data-id="element-94" data-mp="2qgefbrmrqyyk">
        {modules.map(module => <div key={module.title} className="bg-cream border border-gold/40 rounded-lg p-3 sm:p-4 flex gap-2.5 items-start" data-id="element-95" data-mp="2vdws5t3wpybu">
            <CheckCircle2Icon className="w-5 h-5 text-navy shrink-0 mt-0.5" data-id="element-96" data-mp="1v56hh4t39s83" />
            <div data-id="element-97" data-mp="2a1e389k5b1ph">
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy leading-tight mb-1" data-id="element-98" data-mp="2a1xkrp5vvo2z">
                {module.title}
              </h3>
              <p className="text-anthracite text-[12.5px] sm:text-sm leading-relaxed" data-id="element-99" data-mp="250qdrsbkesxd">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}